import { i18n } from '@src/utils/lang'

const { locale } = i18n.global

export const formatSecondaryMarketValue = (
    value: number | string | null | undefined
) => {
    if (value == null || value === '') {
        return '-'
    }

    const numericValue = typeof value === 'number' ? value : Number(value)
    if (Number.isNaN(numericValue)) {
        return '-'
    }

    return numericValue.toLocaleString(locale.value, {
        maximumFractionDigits: 2,
    })
}
